export enum APP_CATEGORIES {
  entertainment = "Entertainment",
  kids = "Kids",
  sports = "Sports",
  moviesandseries = "Movies & Series",
  lifestyle = "Lifestyle",
  information = "Information",
  games = "Games",
  music = "Music",
}

export enum APP_TYPE {
  native = "Native",
  html5app = "HTML5 App",
  opApp = "OpApp",
}

export enum COMMERCIAL_AGREEMENT_TYPE {
  unmonetized = "Unmonetized",
  adInventoryShare = "Ad Inventory Share",
  tivoAdRevshare = "TiVo Ad Rev-share",
  partnerAdRevshare = "Partner Ad Rev-share",
  partnerTvodRevshare = "Partner TVOD Rev-share",
  partnerTvodBounty = "Partner TVOD Bounty",
  partnerSubscriptionRevshare = "Partner Subscription Rev-share",
  partnerSubscriptionBounty = "Partner Subscription Bounty",
  other = "Other",
}

export enum CONTRACT_ORIGIN {
  Xperi = "Xperi",
  Customer = "Customer",
  Foxxum = "Foxxum",
}

export enum CONTRACT_STATUS {
  notSigned = "Not signed",
  signed = "Signed",
  signedFoxxum = "Signed FOXXUM",
  signedCustomer = "Signed Customer",
}

export enum PARTNER_PICKS_REPORTINGS {
  none = "None",
  rail = "Rail",
  full = "Full",
}

export enum PARTNER_PICKS_TYPES {
  none = "None",
  etv = "ETV",
  netflix = "Netflix",
  pcd = "PCD",
  youtube = "YouTube",
}

export enum RECOMMENDATION_TYPES {
  alwaysOff = "Always off",
  alwaysOn = "Always on",
  userControlled = "User controlled",
  inherited = "Inherited",
}

/**
 * Status enum and ReleaseStage type
 *
 * STATUS is a readonly tuple containing all possible status values.
 * ReleaseStage is a subset type containing only release stage statuses (rs1, rs2, rs3).
 *
 * We use this pattern (tuple + type + subset constant) instead of a traditional enum
 * to allow direct access to status values without iteration (e.g., STATUS[3] for "draft").
 *
 * Note: Avoid creating types in this shape unless necessary for direct index access.
 */
export const STATUS = ["rs1", "rs2", "rs3", "draft", "submitted"] as const;
export type Status = (typeof STATUS)[number];
export const STATUS_LABELS: Record<Status, string> = {
  rs1: "RS1",
  rs2: "RS2",
  rs3: "RS3",
  draft: "Draft",
  submitted: "Created",
};

// ReleaseStages - subset of Status
export const RELEASE_STAGES: Extract<Status, "rs1" | "rs2" | "rs3">[] = [
  "rs1",
  "rs2",
  "rs3",
] as const;
export type ReleaseStage = (typeof RELEASE_STAGES)[number];

export const RELEASE_STAGE_LABELS = Object.fromEntries(
  RELEASE_STAGES.map((s) => [s, STATUS_LABELS[s]])
) as Record<ReleaseStage, string>;

export enum SUPPORT_PRIORITY {
  "Tier 1" = "Tier 1",
  "Tier 2" = "Tier 2",
}

export enum URL_PARAMETER_PLACEMENT {
  hashFragment = "Hash fragment",
  query = "Query",
}

export enum YES_NO_UNKNOWN {
  yes = "Yes",
  no = "No",
  unknown = "Unknown",
}
